import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { ForeignInsuredPrintModal } from './ForeignInsuredPrintModal';

type ForeignInsuredPrintModalOpenerRenderProps = { openModal: VoidFunction };
type ForeignInsuredPrintModalOpenerProps = {
   readonly children: (renderProps: ForeignInsuredPrintModalOpenerRenderProps) => ReactElement;
   readonly copyId: number;
   readonly originalId: number;
};

export const ForeignInsuredPrintModalOpener = (props: ForeignInsuredPrintModalOpenerProps): ReactElement => {
   const [{ setFalse: closeModal, setTrue: openModal }, modalOpened] = useBoolean();

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <ForeignInsuredPrintModal copyId={props.copyId} originalId={props.originalId} onClose={closeModal} />
         ) : null}
      </>
   );
};
